import "./App.css";
import Routing from "./Components/common/Routing";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/style.css";

function App() {
  return <Routing />;
}

export default App;
